export default function (app) {
  app.directive('cyc', {
    mounted(el) {
      let index = el.getAttribute('i')
      if (index % 2 == 1) {
        el.style.backgroundColor = 'yellow'
      }
    }
  })
}
